import _extends from "@babel/runtime-corejs3/helpers/esm/extends";
import React from "react";
import PropTypes from "prop-types";
import Modal from "@xo-union/tk-component-modals";
import { MembershipForm, CanSpam, SignUpForm, LogInForm } from "@xo-union/tk-ui-membership-form";

const defaultRenderMembershipForm = (props, ref) => /*#__PURE__*/React.createElement(MembershipForm, _extends({
  ref: ref
}, props));

const MembershipModal = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    onClose,
    openModal: formType,
    children,
    renderMembershipForm,
    ...rest
  } = _ref;
  const emailInputRef = React.useRef(null);
  return /*#__PURE__*/React.createElement(CanSpam, null, _ref2 => {
    let {
      ready
    } = _ref2;

    if (!formType || !ready) {
      return null;
    }

    return /*#__PURE__*/React.createElement(Modal, {
      size: "sm",
      onClose: onClose
    }, renderMembershipForm({
      formType,
      initialFocusRef: emailInputRef,
      ...rest
    }, ref), children);
  });
});
process.env.NODE_ENV !== "production" ? MembershipModal.propTypes = {
  renderMembershipForm: PropTypes.func,

  /**
   * Name of open modal
   */
  openModal: PropTypes.oneOf(['SIGN_UP', 'LOG_IN', null]),

  /**
   * Callback called when clicking on the Log In link
   */
  onClickLogIn: PropTypes.func.isRequired,

  /**
   * Callback called when clicking on the Sign Up link
   */
  onClickSignUp: PropTypes.func.isRequired,

  /**
   * Callback called when the Sign Up form is submitted
   */
  onSignUp: PropTypes.func,

  /**
   * Callback called when the Log In form is submitted
   */
  onLogIn: PropTypes.func,

  /**
   * Callback when overlay (on desktop) or X (on mobile) is clicked
   */
  onClose: PropTypes.func.isRequired,

  /**
   * Metadata about user action necessary for sign up form
   */
  metadata: PropTypes.shape({
    userAction: PropTypes.string.isRequired,
    applicationName: PropTypes.string.isRequired
  }).isRequired,

  /**
   * Whether or not we are waiting for a membership response. Used to render the "loading" state of
   * the modals
   */
  inProgress: PropTypes.bool,

  /**
   * @private Used internally. This will be ignored if passed to component
   */
  children: PropTypes.node,

  /**
   * Signup view. Defaults to SignUpForm
   */
  SignUpView: PropTypes.func,

  /**
   * Login view. Defaults to LogInForm
   */
  LogInView: PropTypes.func
} : void 0;
MembershipModal.defaultProps = {
  children: null,
  openModal: null,
  SignUpView: SignUpForm,
  LogInView: LogInForm,
  renderMembershipForm: defaultRenderMembershipForm
};
export default MembershipModal;